import React, { Fragment } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Outlet, useParams, useLocation } from 'react-router-dom'

import SubMenu from '../../UI/SubMenu/SubMenu'
import { uiConstants } from '../../../constants'
import { alertDelete } from '../../../redux/actions'

const AlertLayout = () => {
  const dispatch = useDispatch()
  const { id, pid } = useParams()
  const { pathname } = useLocation()
  const paths = pathname.split('/').filter((x) => x !== '')

  const deleteHandler = () => {
    dispatch(alertDelete({ id, pid }))
  }

  return (
    <Fragment>
      <SubMenu
        id={id}
        pid={pid}
        links={uiConstants.subMenuAlert}
        paths={paths}
      />
      <Outlet context={[deleteHandler, 'alert', id, pid]} />
    </Fragment>
  )
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps)(AlertLayout)
